export default __webpack_public_path__ + "static/media/digital-blob-left.c4b496bc.svg";